<template>
    <div class="editable-group-batch-upload">
        <upload-button :format="mimetype" :before-upload="onBeforeUpload" :loading="isLoading">
            <template #button>
                <slot></slot>
            </template>
        </upload-button>

        <div v-if="uploadedFile.name" class="editable-group-batch-upload__description">
            <span class="editable-group-batch-upload__name">{{ uploadedFile.name }}</span>
            <span class="editable-group-batch-upload__size">{{ bytesToMegabytes(uploadedFile.size) }}</span>
            <Icon type="md-close" @click="resetUploadedFile" />
        </div>
    </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import { parseStringPromise } from "xml2js";

import { mimetype as mimetypeOptions } from "@/enums/mimetype";
import UploadButton from "@/components/Campaign/UploadButton.vue";

export default defineComponent({
    name: "FeedUploadButton",
    components: { UploadButton },

    emits: ["xmlLoad", "jsonLoad", "error", "resetUploadedFile"],

    data() {
        return {
            isLoading: false,
            uploadedFile: {} as File,
            mimetype: [] as (typeof mimetypeOptions)[keyof typeof mimetypeOptions][]
        };
    },
    created() {
        this.mimetype = [mimetypeOptions.XML, mimetypeOptions.JSON];
    },

    methods: {
        onBeforeUpload(file: File) {
            this.uploadedFile = file;
            if (file.type === mimetypeOptions.XML) {
                this.readXml(file);
                return false;
            }

            if (file.type === mimetypeOptions.JSON) {
                this.readJson(file);
                return false;
            }

            this.$emit("error", "The file needs to be either XML or JSON.");
            return false;
        },

        async readXml(file: File) {
            try {
                this.isLoading = true;
                const str = await file.text();
                const importData = await parseStringPromise(str);

                this.$emit("xmlLoad", importData);
            } catch (e) {
                this.$snackbar.error(e as string);
            }
            this.isLoading = false;
        },

        async readJson(file: File) {
            try {
                this.isLoading = true;
                const str = await file.text();
                const importData = await JSON.parse(str);
                this.$emit("jsonLoad", importData);
            } catch (e) {
                this.$snackbar.error(e as string);
            }
            this.isLoading = false;
        },

        resetUploadedFile() {
            this.uploadedFile = {} as File;
            this.$emit("resetUploadedFile");
        },

        bytesToMegabytes(bytes: number) {
            const megabytes = bytes / 1048576;
            return `${megabytes.toFixed(2)} MB`;
        }
    }
});
</script>
